import { render } from "./BannerStyle.vue?vue&type=template&id=79af2b80"
import script from "./BannerStyle.vue?vue&type=script&lang=js"
export * from "./BannerStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__